import { Microfrontend } from '@cian/mf-react';
import { JsonObject } from '@cian/mf-react/shared/types/json';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useFiltersUpdatedEvent, useSaveSearchModal, useTooltipDisabled } from './hooks';
import { SaveSearchModalContainer } from '../FiltersContainer/SaveSearchModalContainer';
import { IAppState } from 'shared/common/state';
import { EPosition } from 'shared/filters/components/filters/types';
import { IPuidsSchema } from 'shared/repositories/search-offers/entities/entities/PuidsSchema';
import { selectIsAgent } from 'shared/selectors/user';
import { useApplicationContext } from 'shared/utils/applicationContext';

interface IDesktopFiltersMicrofrontendProps {
  filtersSectionPosition: EPosition;
}

export const DesktopFiltersMicrofrontend: React.FC<IDesktopFiltersMicrofrontendProps> = ({
  filtersSectionPosition,
}) => {
  const { config } = useApplicationContext();

  const manifest = config.get<IMicrofrontendManifest | null>('desktopFiltersMicrofrontendManifest');

  useFiltersUpdatedEvent();

  const isTooltipDisabled = useTooltipDisabled({ filtersSectionPosition });

  const { open, onModalClose, onModalOpen, onSubscribed, subscribeToPush } = useSaveSearchModal();

  const userIsAgent = useSelector(selectIsAgent);

  const adfoxPuids = useSelector<IAppState, IPuidsSchema>(state => state.results.puids || ({} as IPuidsSchema));

  return (
    <>
      {manifest && (
        <Microfrontend
          name={manifest.microfrontendName}
          image={manifest.imageVersion}
          runtime={manifest.runtimeName}
          instance={manifest.instanceId}
          parameters={{
            searchMetaTooltipEnabled: !isTooltipDisabled,
            adfoxPuids: adfoxPuids as unknown as JsonObject,
            professionalSearchAvailable: userIsAgent,
          }}
        />
      )}
      <SaveSearchModalContainer
        isOpen={open}
        onSubscribed={onSubscribed}
        onPushSubscribed={subscribeToPush}
        onOpen={onModalOpen}
        onClose={onModalClose}
      />
    </>
  );
};
